/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Report_ButtonInputs */



/**
* | output |
* | --- |
* | "Report" |
*
* @param {Style_Guide_Report_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_report_button = /** @type {((inputs?: Style_Guide_Report_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Report_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rapport")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bericht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rapporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отчет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Informe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("报告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("報告")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिवेदन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relatório")
	return /** @type {LocalizedString} */ ("Report")
});